import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { StripeProvider } from 'react-stripe-elements';
import store from './store';
import './css/app.css';
import './css/custom.css';
import './css/tachyons.css';
import './css/skins.css';

const stripeKey =
  process.env.NODE_ENV === 'production'
    ? 'pk_live_sy0ZT3XBxUtIq7rh8zUR5BJq'
    : 'pk_test_nDRPNbQsQ2zzMUJAnbe2AMDe';

ReactDOM.render(
  <Provider store={store}>
    <StripeProvider apiKey={stripeKey}>
      <App />
    </StripeProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js